import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  description: {
    marginTop: 6,
    marginBottom: 10,
    textAlign: 'justify',
  },
  allDoneText: {
    margin: '20px 0',
    fontStyle: 'italic',
    textAlign: 'center',
  },
  analysisTitle: {
    marginBottom: 15,
  },
  recommendedAnalysisTitle: {
    marginTop: 25,
  },
  icon: {
    marginRight: 15,
    height: '100%',
  },
  errorIcon: {
    fontSize: '1.5rem',
  },
  warnIcon: {
    fontSize: '1.2rem',
  },
}));
